import { CommonModule } from '@angular/common';
import { ErrorHandler, NgModule } from '@angular/core';
import { AppInsightsLogger } from 'src/app/shared/shared-base/amg-ui/logging/logging/app-insights-logger';
import { ConsoleLogger } from 'src/app/shared/shared-base/amg-ui/logging/logging/console-logger';
import { Logger } from 'src/app/shared/shared-base/amg-ui/logging/logging/logger';
import { LoggingErrorHandler } from 'src/app/shared/shared-base/amg-ui/logging/logging/logging-error-handler';
import {
  LOGGING_ADAPTERS,
  MultiLogger,
} from 'src/app/shared/shared-base/amg-ui/logging/logging/multi-logger';
import { ModuleWithProvidersStrict } from 'src/util/angular/ng-core';

@NgModule({
  imports: [CommonModule],
  declarations: [],
})
export class LoggingModule {
  public static forRoot(): ModuleWithProvidersStrict {
    return {
      ngModule: LoggingModule,
      providers: [
        { provide: LOGGING_ADAPTERS, useClass: AppInsightsLogger, multi: true },
        { provide: LOGGING_ADAPTERS, useClass: ConsoleLogger, multi: true },
        { provide: Logger, useClass: MultiLogger },
        { provide: ErrorHandler, useClass: LoggingErrorHandler },
      ],
    };
  }
}
